<template>
  <div>
    <h4 class="" style="font-weight: 500; margin-bottom: 0;"><span v-if="user.status == 'Application Approved'">Step 2: </span>Package Selection</h4>
    <hr>
    <div v-if="!user.selector8">
      <button class="mylisting-button dark-button" @click="showPackageSelectionModal()">Select Package</button>
    </div>
    <div v-if="user.selector8">
      <p>Package Selected: {{ user.selector8 }}</p>
      <!-- <button class="mylisting-button dark-button" @click="resetPackage()">Reset Package</button> -->
    </div>

    <modal name="package-selection-modal" width="95%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <div class="document">
          <!-- <img src="../../../assets/img/logo/NAN_logomark_RGB_Evergreen.png" alt="" class="center" style="width: 110px; padding-bottom: 10px;"> -->
          <h3 style="text-align: center;">Placement Packages</h3>
          <hr>
          <p class="center" style="font-size: 1rem;">Please note that all placement fees are a minimum of $5,000, and all fees are calculated on the basis of annual compensation.</p>
          <!-- <p>We're looking forward to customizing our search for your family! As every client has their own preference in their involvement of their Nanny search, we wanted to provide you with two options. Upon your selection, we'll begin working within the appropriate package.</p>
          <p>Each package begins with our diligent screening process:</p>
          <ul>
            <li>Diligent review of Application</li>
            <li>Social Media Screening</li>
            <li>Phone Interview</li>
            <li>In-Person Interview</li>
            <li>Thorough Reference Checks</li>
            <li>Clear Criminal Record Check</li>
            <li>Clear Child Abuse Check</li>
            <li>Updated CPR/First Aid Level C</li>
            <li>Drivers Abstract</li>
          </ul> -->

          <hr>

          <div class="row">
            <div class="col-lg-4 py-2 px-2" >
              <div class="px-5 py-3" style="border: 1px solid black;">
                <h4 class="mt-4 center mb-4">Standard</h4>
                <p>A placement fee of 16% of the employee’s total gross annual compensation package.</p>
                <p>The following benefits are included as part of the Standard Placement Package:</p>
                <ul>
                  <li>One Day Trail Period</li>
                  <li>30-Day Replacement Policy</li>
                  <li>Security Background Investigation</li>
                  <li>Verification of First Aid/CPR Certification</li>
                </ul>
                <button class="mylisting-button dark-button mt-4 mb-3 center" @click="showConfirmPackageSelectionModal('Standard')">Select Standard</button>
              </div>
            </div>
            <div class="col-lg-4 py-2 px-2">
              <div class="px-5 py-3" style="border: 1px solid black;">
              <h4 class="mt-4 center mb-4">Premiere</h4>
              <p>A placement fee of 18% of the employee’s total gross annual compensation package.</p>
              <p>The following benefits are included as part of the Premiere Placement Package:</p>
              <ul>
                <li>Three Day Trail Period</li>
                <li>60-Day Replacement Policy</li>
                <li>Security Background Investigation</li>
                <li>Criminal History Search Including All Locations Lived in During the Past 7 Years</li>
                <li>Auxiliary National Criminal Search Including Records for the Past 7 years</li>
                <li>Global Terrorist Search</li>
                <li>Verification of First Aid/CPR Certification</li>
                <li>Professionally Drafted Employment Agreement Tailored to Your Household</li>
                <li>Professionally Drafted Confidentiality Agreement (Upon Request)</li>
                <li>10-Panel Drug Test (Upon Request)</li>
              </ul>
              <button class="mylisting-button dark-button mt-4 mb-3 center" @click="showConfirmPackageSelectionModal('Premiere')">Select Premiere</button>
              </div>
            </div>
            <div class="col-lg-4 py-2 px-2">
              <div class="px-5 py-3" style="border: 1px solid black;">
              <h4 class="mt-4 center mb-4">Elite</h4>
              <p>A placement fee of 20% of the employee’s total gross annual compensation package.</p>
              <p>The following benefits are included as part of the Elite Placement Package:</p>
              <ul>
                <li>Five Day Trail Period</li>
                <li>120-Day Replacement Policy</li>
                <li>Security Background Investigation</li>
                <li>Criminal History Search Including All Locations Lived in During the Past 7 Years</li>
                <li>Auxiliary National Criminal Search Including Records for the Past 7 years</li>
                <li>Global Terrorist Search</li>
                <li>Verification of First Aid/CPR Certification</li>
                <li>Professionally Drafted Employment Agreement Tailored to Your Household</li>
                <li>Professionally Drafted Confidentiality Agreement (Upon Request)</li>
                <li>Degree Verification (Upon Request)</li>
                <li>10-Panel Drug Test (Upon Request)</li>
                <li>Do Not Text and Drive Policy</li>
                <li>Covid-19 Policy Agreement</li>
                <li>Orientation Binder</li>
                <li>Themed Weekly Curriculums for your Nanny</li>
                <li>One Year of Complimentary Temporary Nannies to Fill-In During Your Nanny’s Vacation or Sick Days (Complimentary agency fee. Client is expected to compensate the nanny at her regular hourly rate.)</li>
              </ul>
              <button class="mylisting-button dark-button mt-4 mb-3 center" @click="showConfirmPackageSelectionModal('Elite')">Select Elite</button>
              </div>
            </div>
          </div>

          <!-- <h4 class="mt-4">Standard</h4>
          <p>A placement fee of 16% of the employee’s total gross annual compensation package.</p>
          <p>The following benefits are included as part of the Standard Placement Package:</p>
          <ul>
            <li>One Day Trail Period</li>
            <li>30-Day Replacement Policy</li>
            <li>Security Background Investigation</li>
            <li>Verification of First Aid/CPR Certification</li>
          </ul>
          <button class="mylisting-button dark-button mt-3 mb-2" @click="showConfirmPackageSelectionModal('Standard')">Select Standard</button>

          <hr>

          <h4 class="mt-4">Premiere</h4>
          <p>A placement fee of 18% of the employee’s total gross annual compensation package.</p>
          <p>The following benefits are included as part of the Premiere Placement Package:</p>
          <ul>
            <li>Three Day Trail Period</li>
            <li>60-Day Replacement Policy</li>
            <li>Security Background Investigation</li>
            <li>Criminal History Search Including All Locations Lived in During the Past 7 Years</li>
            <li>Auxiliary National Criminal Search Including Records for the Past 7 years</li>
            <li>Global Terrorist Search</li>
            <li>Verification of First Aid/CPR Certification</li>
            <li>Professionally Drafted Employment Agreement Tailored to Your Household</li>
            <li>Professionally Drafted Confidentiality Agreement (Upon Request)</li>
            <li>10-Panel Drug Test (Upon Request)</li>
          </ul>
          <button class="mylisting-button dark-button mt-3 mb-2" @click="showConfirmPackageSelectionModal('Premiere')">Select Premiere</button>

          <hr>

          <h4 class="mt-4">Elite</h4>
          <p>A placement fee of 20% of the employee’s total gross annual compensation package.</p>
          <p>The following benefits are included as part of the Elite Placement Package:</p>
          <ul>
            <li>Five Day Trail Period</li>
            <li>120-Day Replacement Policy</li>
            <li>Security Background Investigation</li>
            <li>Criminal History Search Including All Locations Lived in During the Past 7 Years</li>
            <li>Auxiliary National Criminal Search Including Records for the Past 7 years</li>
            <li>Global Terrorist Search</li>
            <li>Verification of First Aid/CPR Certification</li>
            <li>Professionally Drafted Employment Agreement Tailored to Your Household</li>
            <li>Professionally Drafted Confidentiality Agreement (Upon Request)</li>
            <li>Degree Verification (Upon Request)</li>
            <li>10-Panel Drug Test (Upon Request)</li>
            <li>Do Not Text and Drive Policy</li>
            <li>Covid-19 Policy Agreement</li>
            <li>Orientation Binder</li>
            <li>Themed Weekly Curriculums for your Nanny</li>
            <li>One Year of Complimentary Temporary Nannies to Fill-In During Your Nanny’s Vacation or Sick Days (Complimentary agency fee. Client is expected to compensate the nanny at her regular hourly rate.)</li>
          </ul>
          <button class="mylisting-button dark-button mt-3 mb-2" @click="showConfirmPackageSelectionModal('Elite')">Select Elite</button> -->
        </div>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('package-selection-modal')">Cancel</button>
      </div>
    </modal>

    <modal name="confirm-package-selection-modal" width="85%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Confirm Selection - {{ packageSelection }}</h2>
        <hr>
        <h5>I have read and am confident of the terms of the package chosen.</h5>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('confirm-package-selection-modal')">Cancel</button>
        <button class="mylisting-button dark-button" @click="selectPackage()" style="float: right;">Confirm Selection</button>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: ['user'],
  data() {
    return {
      packageSelection: '',
    }
  },
  methods: {
    showPackageSelectionModal() {
      this.$modal.show('package-selection-modal')
    },
    showConfirmPackageSelectionModal(packageSelection) {
      this.packageSelection = packageSelection
      this.$modal.show('confirm-package-selection-modal')
    },
    selectPackage() {
      axios.patch(`/api/people/${this.user.id}/`, {
        selector8: this.packageSelection,
        status: 'Package Selected',
      })
        .then(res => {
          console.log(res)
          this.$modal.hide('package-selection-modal')
          this.$modal.hide('confirm-package-selection-modal')
          this.$emit('userUpdated')

          this.$store.dispatch('sendEmails',
            {
              subject: `Package Selected - ${this.user.first_name} ${this.user.last_name} | ${this.packageSelection}`,
              message: '<p>Hello,' + '\n\n</p>' +
              `<p>The client ${this.user.first_name} ${this.user.last_name} just selected the following package: <strong style="color: #e70d7b;">${this.packageSelection}</strong>\n\n</p>`+
              '<p>Cheers!</p>',
              from: this.$store.getters.agencyFromEmail,
              emails: [this.$store.getters.enginehireLoggingEmail, this.$store.getters.agencyAdminEmail],
              reply: this.$store.getters.agencyReplyEmail,
              // userID: this.aakashid,
              userID: 4,
              html: true,
            }
          )
        })
        .catch(error => {
          console.log(error)
        })
    },
    resetPackage() {
      axios.patch(`/api/people/${this.user.id}/`, {
        selector8: '',
        // status: 'Interview Complete',
      })
        .then(res => {
          console.log(res)
          this.$modal.hide('package-selection-modal')
          this.$modal.hide('confirm-package-selection-modal')
          this.$emit('userUpdated')
        })
        .catch(error => {
          console.log(error)
        })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/employers/profile/PackageSelection.vue